import 'css-chunksrc/client/scenes/planzoneResourceToProject/resourceToProjectForm/resourceSelection/selectedResourcesList/addResourcesButton/styles.scss';export default {
  "form": "_form_6v2lw_1",
  "quickAllocationMenu": "_quickAllocationMenu_6v2lw_7",
  "group": "_group_6v2lw_14",
  "icon": "_icon_6v2lw_21",
  "openAllocatorButton": "_openAllocatorButton_6v2lw_30",
  "removeButton": "_removeButton_6v2lw_35",
  "clearButton": "_clearButton_6v2lw_45"
};